export const performValidation = (value) => {
  for (const key in value) {
    if (!value[key]) return false;
  }
  return true;
};
